import { h, render } from "preact";
import App from "./App";
import '@fortawesome/fontawesome-free/css/all.css'
import "./css/fonts.css"

render(<App />, document.getElementById("root")!);
